// AUTO-GENERATED by scripts/build-assets.ts — do not edit by hand.
// Run `pnpm --filter web assets:build` after changing assets/curated/.

export interface PhotoEntry {
  base: string;
  folder: string;
  widths: number[];
  aspect: number;
  lqip: string;
}

export interface PhotoManifest {
  hero: PhotoEntry | null;
  story: PhotoEntry[];
  gallery: PhotoEntry[];
  misc: Record<string, PhotoEntry>;
}

export const photos: PhotoManifest = {
  "hero": {
    "base": "hero",
    "folder": "hero",
    "widths": [
      480,
      1280,
      2560
    ],
    "aspect": 1.5,
    "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAQABgDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAABQACA//EACEQAAICAQMFAQAAAAAAAAAAAAECAxEABBMhBRIxQWFx/8QAFgEBAQEAAAAAAAAAAAAAAAAAAwAB/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQACEv/aAAwDAQACEQMRAD8AIXULuGIqAaJBA8VnAuQsTIzqQSB8/MVHSEaVpe5rN8Eiuc3J0wzRQoJFURCha+cESRyxU88tLuP3ApwW9HLGF0EcEDLJtye7IIrLI1Zw3//Z"
  },
  "story": [
    {
      "base": "1",
      "folder": "story",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAMEBQEG/8QAKhAAAgEDAgQEBwAAAAAAAAAAAQIDAAQREiEFEzFBIjJRYUJxgYKRkuH/xAAXAQEBAQEAAAAAAAAAAAAAAAACAQMA/8QAGREBAQEBAQEAAAAAAAAAAAAAAAERAjEh/9oADAMBAAIRAxEAPwDz9rCZ3AOyjrWqETl8vAKkYIrkSRxoQpHKQE6vaqx4igl0iFSnpnxfmsvTmRVvYWgk65Rtw1K1HSOWNQ2OS41ajsR/aVZUvKB5Va1ljjOW8IA+4UvOBPa2huDIraFyxU981BbwhnkTDIGAwQD1znvXont1uOGSpKWxoUZ71Y66xYWUcPTWR53Az9KV26tlito4wDIAxIJ67j2+VKOrlTQzOT8P6irqF3DapHwD5c7UpWZcffUUkrAsARsfSlKUQtr/2Q=="
    },
    {
      "base": "2",
      "folder": "story",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 1.5,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAQABgDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAMEBf/EAB4QAAIDAAMBAQEAAAAAAAAAAAECAAMRBBIxITJB/8QAFQEBAQAAAAAAAAAAAAAAAAAAAwL/xAAYEQADAQEAAAAAAAAAAAAAAAAAASERMf/aAAwDAQACEQMRAD8Ah4LGt1UDQ3z2W3VWhQFUKD+tOnJmUMww9syWs1rOgezQcHnohKCPGqOvoTlp0V+qIfpH9MI691p45OABRuCEvgbp/9k="
    },
    {
      "base": "3",
      "folder": "story",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAIDBAX/xAAlEAACAgEEAQMFAAAAAAAAAAABAgARAwQSITGBBRNBI1JhcfD/xAAXAQADAQAAAAAAAAAAAAAAAAAAAQID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAAECEv/aAAwDAQACEQMRAD8AxZE+sQDR6HiYywxkfceb+P7uWLmOxCoJcG6rxM2sG1wK45rwZhJVVB2oML75qJENS7yLFRLS6OPR5l1HuHInf7M2+oaJcumyNtRX3AKR1+ZLetWPjiGyFgbY1d1XEzmjcdtA4BokxOmxoRDukqQnbLR1ESTQyMdsREYf/9k="
    },
    {
      "base": "4",
      "folder": "story",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGgABAQACAwAAAAAAAAAAAAAAAAQBAwIFBv/EACQQAAICAQIGAwEAAAAAAAAAAAECABEDITEEEhMiQVFhgZEF/8QAFwEBAQEBAAAAAAAAAAAAAAAAAQIABP/EABgRAQEAAwAAAAAAAAAAAAAAAAABAhES/9oADAMBAAIRAxEAPwCTICMrXtpp9SdcZ5VyZRaE0B7m8uGCk0CwI/ZFmYrRDUQBsfic8XWGNK9Aa7aRNZ72tj2sNz4iXEt/BHqcRTKeW9yNB61l/G/xh1EXFkZuwknbXxXxKL7d9/Eu4Zazlj3FcXr3DG7Lx5XIEKPjOnmJ3bYsZFlR+RDsMK5O85OWsnmayNTcRIhTuzAXzH7MREyX/9k="
    },
    {
      "base": "5",
      "folder": "story",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgMF/8QAJBAAAgEEAgIBBQAAAAAAAAAAAQIAAxEhMQQSIkETFBVRcZH/xAAYAQEBAAMAAAAAAAAAAAAAAAABAAIDBP/EABgRAQEAAwAAAAAAAAAAAAAAAAABERIx/9oADAMBAAIRAxEAPwDn4+NWJ883zIUILEm3v9RcP2pnHr3IDgrvGpzszlPlHsLOynQs1rQiKhg42c5MI8Sj1DgDAEvX4tTi1KYc+LqHH5mycRw6uShta4IuDGefR+t5C1ewXxAso1HMDm9/LcI39uAyXP8AIQ2iN09SxchrC0ITWWVSow1aEIRD/9k="
    }
  ],
  "gallery": [
    {
      "base": "img-4585",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.666,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAFwABAQEBAAAAAAAAAAAAAAAAAAQFA//EACUQAAIBAwMEAgMAAAAAAAAAAAECEQADBBITIQUxQVEiYSNxkf/EABcBAAMBAAAAAAAAAAAAAAAAAAACAwH/xAAaEQADAAMBAAAAAAAAAAAAAAAAAQIRITFB/9oADAMBAAIRAxEAPwCe7mlre8V+SjTAHHua42s1cpoddJ44juK0uo4NvCwwFGoT8yT59/qocBUN12ASLawvHImoOUtFVvZKzPav3Wtkgggg/RpVmc5bHZiqgAAzFK1Z8FZu3nDmGAI8zWJZwb6dVbbIGKzSZPER6rZtxcEHyKnsuu0ymdxGhvo9v5T0EkmfifjbQdSMpieOfVK65JJBHgGaVJ1jgPpPn5N23ea3bbQsxx3qXHzbwdZIPMGR3FKVtdHkoc7zFm7gGIMUpShDH//Z"
    },
    {
      "base": "img-4628",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAMEBQEG/8QAIxAAAQQCAQQDAQAAAAAAAAAAAQACAxEEIRIFMUFxE1Fhkf/EABYBAAMAAAAAAAAAAAAAAAAAAAECA//EABkRAQEAAwEAAAAAAAAAAAAAAAEAAhEhMf/aAAwDAQACEQMRAD8A87GXPPAGyewHlUZQfG9rZCBQFEDRTsWKLHhMz3AGtu+vz2mExZ0BDSTR0SK4n79KM+qD5g0aLm77VdISnQyhxABdvRHlCOiHavIc6SF8QjOnA62fK1ZsWLFw3ywMPEBoaDrlfe/4F2GCFjgWsAJVzy6SAw/Czhd73aUyNTe9LCi6dk5BMkbWhpFi3eEKvJnkwmtZHAwtI82EJw2U3IGfFI4tFUPQpUkmu6EKuIUFbN6rbIBIDsGt9kIQhkdjg8v/2Q=="
    },
    {
      "base": "img-4685",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAQFAgP/xAApEAACAQMDAwEJAAAAAAAAAAABAgMABBESITETQVEFFCIyYYGRobHB/8QAFwEBAQEBAAAAAAAAAAAAAAAAAQIAA//EABoRAQEBAAMBAAAAAAAAAAAAAAEAEQISMSH/2gAMAwEAAhEDEQA/AJNlalAJHGWPbxTwicge6d+B3P0rHU0RSTkbqMgHcAk/yo89wzTamJZs7t3rj9a9CpXdsLiPPEi/CfPyordvL7RbCRzqdG0sccjkZorak4Ms111bW4RRthf3VRPR7SOx1zpiRVJd3Y7eRStnbzx3BZ48glcZyQO+ar3brJEyGLVknIPB35pEyMdoNvIkFnORkqJFA/NFPT25EBFvEEJIJC7ZoqdJ6tiEkkZYnfzTkSKATjeiionh5cp2Ks2GP3ooooofb//Z"
    },
    {
      "base": "img-4691",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGAABAAMBAAAAAAAAAAAAAAAAAAMEBQb/xAAkEAACAQMDBQEBAQAAAAAAAAABAgMAERIEIWEFEzFBUXEiMv/EABgBAQADAQAAAAAAAAAAAAAAAAMAAQIE/8QAGhEBAQEBAAMAAAAAAAAAAAAAAQIAESExQf/aAAwDAQACEQMRAD8AxtUvYcOoXtn1zVrpU65hHOHcNrAmx/ajSRdVpnzW4GxsLX+VUWKSG5DsCoBvj4BoGenMnp7uh1fVl0qsFOL72Ftx8P5SuZnlaQnJy300q4jhs09du9KgfRS3dQ+bCxA/z59Vf1Omgmh1BEBBYD+lBG3NUo5irqLnc2FbMWJhdGZRkni/FXL0079Nys/Tcd40cnkilbE8SxgEsxy8UqBabNXMvHQRAWO1yRufdSRoBkbsTyfXylKLdBo9PMz6p4Hs0ZF7H0eKUpSyoYqkXyb/2Q=="
    },
    {
      "base": "img-4706",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 1.5,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAQABgDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAIFBP/EACQQAAIBBAECBwAAAAAAAAAAAAEDAgAEERITFCEjQUJRYXGh/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQID/8QAFxEBAQEBAAAAAAAAAAAAAAAAAAEhEf/aAAwDAQACEQMRAD8AmlCioqSTzAbffxS9Xc2qBAx0MhmJ9xVWytVpZFkAeQeoyxT3iFO1DUzOowJQjmssqkFz4sAJn5ftFb22CZ5I5wT3PhminIOV/9k="
    },
    {
      "base": "img-4707",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAUCAwYE/8QAJxAAAgIBAwMEAgMAAAAAAAAAAQIAAxEEEiEUMYEiQVFhBTJikcH/xAAXAQEBAQEAAAAAAAAAAAAAAAABAwIA/8QAGxEBAQEAAgMAAAAAAAAAAAAAAAERAhIhUXH/2gAMAwEAAhEDEQA/AFK6t1INZH3jjIndRr8suW4X1YxyZz36Wt6DXVgOnI558xdXc9THggjgg/Ml1ljW2Nd1lW1msIAAzgnmEy12sdtqbgRnJ+jCE4OvIz/H6EBuotc7iWIrxnPJ7mUtor7SzoyqrHIGfb4jSgN3TjxJ3egArW7A9yO48R3TJ4Zu3R2V2DewYZ9swjptZQvDhwf5V5/2E3Pqd30pptsAA3scD3Mu6q1T+39whInU+odh6tp8QhCKkf/Z"
    },
    {
      "base": "img-4711",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAQFAwEC/8QAJBAAAgEEAQQCAwAAAAAAAAAAAQIAAwQREiEFEzFRYXGBkaH/xAAXAQEBAQEAAAAAAAAAAAAAAAABAgAD/8QAGBEBAQEBAQAAAAAAAAAAAAAAAAERAhL/2gAMAwEAAhEDEQA/AErO2FRDUq8BhhRjH5jdre9odrCqVyHJ9zC4uzSSkRhS/JyucD1PPUrcNTWujaEnVwfqcV43e8WqhYEec+fEJFqu2mg1OowDjEIzlOn7ezrXADFyNTwGU/yX+213bvSYU6gYDY4wf3JyXAPk5jIrGnSQKxG/OB6hOjsTbjpWxZbcAEcEl4SiX+YQ9VrYkqxmtOq7KFY514H1CEEx16reMwhCAf/Z"
    },
    {
      "base": "img-4719",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQABAAMBAQAAAAAAAAAAAAAAAAIDBAUG/8QAIxAAAgICAgIBBQAAAAAAAAAAAQIAAxEhBBIxQRMFImFxgf/EABgBAQEAAwAAAAAAAAAAAAAAAAECAAME/8QAGBEBAQADAAAAAAAAAAAAAAAAAAEREjH/2gAMAwEAAhEDEQA/AKgwrC5A7bxuZ25Trb2TBbYIkrHVyuPGgfxmYbrPjb+kk+5zyLtL7GuYscImdgaETO7HYH7iXhDQjsVFWQGf2PUj9SrtrsPZGABwSR78zpJxKO6v8Y7eskzXy0pu4zKxVj8gIXt4GMQlnS8uLMJo/djBidSzh1Y8YiO8C1LWwZMWEruImsqrHIGoiJgf/9k="
    },
    {
      "base": "img-4727",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.666,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAQFAgP/xAAnEAACAgEDAwIHAAAAAAAAAAABAgADEQQSITFBYRMiBRRRUpGhwf/EABYBAQEBAAAAAAAAAAAAAAAAAAECA//EABsRAQEAAwADAAAAAAAAAAAAAAABERIhAjFR/9oADAMBAAIRAxEAPwCeusbG3KWJrBGOc5k9qbK7FcY2kZHjHE1Wr01NDLo7R6nbc+cD+TLurtrLiwcMpIxyD5mGuGjl7NOdOKQPTZT72boc46YiUqqPpkqKqAw545JMSsjVW/w0WlAL3qVRtZa+NwnD107jpwgRFbbuz1GO8ob5usgBabB9clf1IHLvqGTplyvHQyvK8E51tGnSCrKKgIGQYni+mwmKWK+Dyv4iFl+GWJGvsN4XOAAeB3nhR7tcufvzEQvsNcE8xETVL//Z"
    },
    {
      "base": "img-4730",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAMEAQIF/8QAJBAAAgEDAwQDAQAAAAAAAAAAAQIAAwQREiExEyJBYTJRcaH/xAAXAQEBAQEAAAAAAAAAAAAAAAACAwQA/8QAHBEBAAIDAAMAAAAAAAAAAAAAAAExAhEhEmFx/9oADAMBAAIRAxEAPwCCpVTSNLAgjxMo3bOvT16h8c/QjUsjZ3hdnGQxH7HWyq951WoUtSA4VT75MjOp4r4zaRu+qccEfXMJe7M4ZSAccGEPx1G3tm1ev1GcrnkjaYumlaKgADEnDHBP8i7m9uad0lCqF1OuRoOcD3O1udCimR2n5EjiOR37IpiowRD2lwDqO/7CXVVQKvcAyjC+x6hDRx14VjVeu9a4qsXq5C5PgSkMSdzCEWVs59OqylU2ZWzsfGIQhA04U//Z"
    },
    {
      "base": "img-4733",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGgABAAIDAQAAAAAAAAAAAAAAAAMEAQIFBv/EACgQAAIBAwIFAwUAAAAAAAAAAAECAwAEEQUhEhMxQVEUMmEVInKBof/EABcBAQEBAQAAAAAAAAAAAAAAAAMBAgD/xAAbEQACAgMBAAAAAAAAAAAAAAAAARExAiFRYf/aAAwDAQACEQMRAD8A01jTzJOY4ISIQockE4XyAO1U9MRAwjIJAzhgN1+c+K9I00bAJv8Ad5qC602DlKkeFk9yuo3Hn9Ubx1o0nFnIuuVdRRwPIweJQqP2Jx3pUvoWVjI6LyVOTvvtmlE21QkJ2YN9JEluSQwcdeHOauvqgRkDJnAwGHcVVgPFFbq0yiMoAFKD+UQOl3wMEK4JUgYIpV4HPTXVLtns3dcqntAx3PU0qfU4ll02XcgopO3fpSuoy2cu0kYwICc8OQPipbV2a/lyScYA+KUqIpeuSfp1x+JpSlXIyf/Z"
    },
    {
      "base": "img-4738",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQAAAwEBAQAAAAAAAAAAAAAAAAQFAgMG/8QAJBAAAQQBAwQDAQAAAAAAAAAAAQACAxEEEiEiE0FRYQUxcRT/xAAYAQEBAAMAAAAAAAAAAAAAAAACAQADBP/EABkRAQEBAAMAAAAAAAAAAAAAAAABAhESMf/aAAwDAQACEQMRAD8A4RmV7Y4BvFvbWnkL9p1sjMbFxiInO4anE+lGimp4qwAasnS4+im58h82C0kUWWAQPJXORPIndLJuBYsi/CEpNMTsew7oTmRUMcj+ljsk2A4ce7lSzxFkYsz9AY/TyLfofqTiiY0jpgA3991UdH1cTJDjeppFfimbyryD2AG3cvZKFRk+MjO42Qr2gtNkdtuujp5dTndRw10SAdkIWuFPGHSO8oQhYL//2Q=="
    },
    {
      "base": "img-4742",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 1.5,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAQABgDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAwUG/8QAIhAAAgICAgEFAQAAAAAAAAAAAQIDIQARBBJxBRMxQWGR/8QAFgEBAQEAAAAAAAAAAAAAAAAAAQID/8QAFhEBAQEAAAAAAAAAAAAAAAAAAQAR/9oADAMBAAIRAxEAPwDHUe+yRR9mkpVOt7/BjscHKjWRGBSirhm+D9b85PpzMeUkkjoOisaW96xxJXn5DxMiSdRbtXj+ZjgkjczM52VN6qsMs5oK8mQqDrsbGGWRf//Z"
    },
    {
      "base": "img-4744",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 1.5,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAQABgDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAE/8QAHxAAAgIDAAIDAAAAAAAAAAAAAQIDEQAEIRJBBTFh/8QAFAEBAAAAAAAAAAAAAAAAAAAAAP/EABQRAQAAAAAAAAAAAAAAAAAAAAD/2gAMAwEAAhEDEQA/ACNzchkZHg11hFWaJPc1621C/wAZLCsDGQ1RUnxNd7+9w3VAk2oVD+Xk4BFUKvFNjaE+y0TRAM3uBgAyj6BGAFK4JNCsstlQk7jnGPu8sD//2Q=="
    },
    {
      "base": "img-4750",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGAABAQEBAQAAAAAAAAAAAAAAAAUDAgH/xAAkEAEAAgICAQMFAQAAAAAAAAABAAIDERIhMUFRcQUTMmGB8P/EABcBAQEBAQAAAAAAAAAAAAAAAAIBAAP/xAAZEQEAAwEBAAAAAAAAAAAAAAAAAREhAkH/2gAMAwEAAhEDEQA/AJdL88autdATPOiN/cF+dzPFibWxVx6KrpVPPxKWb6Vly0qYLVpXi/l/vX3nGI0/EU02a63uJxxsWGouvSIgXypUeNK115dSll+846WOuFTd7fs8BJrY4lfSWst8bhac69gGmDjbW0BxVempE7bn9Ig1mI73PWlXvWkekiJWY+FBiIlR/9k="
    },
    {
      "base": "img-4757",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGAAAAwEBAAAAAAAAAAAAAAAAAAMFBAH/xAAmEAACAgICAAUFAQAAAAAAAAABAgADERIEIQUxQVFhEyIjcaHw/8QAFwEAAwEAAAAAAAAAAAAAAAAAAAECA//EABgRAQADAQAAAAAAAAAAAAAAAAABAhEh/9oADAMBAAIRAxEAPwCIeRtlPpMGHnjucrt1co2wA7IIlTwri0X2WPaDschSD/veNfwvPPrFL/awy5sGclZnnFJZ/IjEDrIP6hNPNqspsarUMCckr6dQkCWug6Fm2ZcjojGf7N1Cq3MYPltVHn8yYGGcZ8/UylVbVVffvaocleifiOkjWLnLpynVOhCN8RspZldHBsPTKISLR0tTQTiLyW3djlsnuEIwWMjrJ69zCEIE/9k="
    },
    {
      "base": "img-4767",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGgABAAIDAQAAAAAAAAAAAAAAAAMEAQIFBv/EACcQAAICAQMDAgcAAAAAAAAAAAECABEDBBIxEyFhQVEFFBUyQnHw/8QAGAEAAwEBAAAAAAAAAAAAAAAAAAECAwT/xAAZEQEBAQEBAQAAAAAAAAAAAAAAARECITH/2gAMAwEAAhEDEQA/AIMoV8aV2paEp5NivkdrsGlrtX8JjBqQ2E8knx7TGdqRnIrcRf7InNJY0t1HmcFg1hjwPMSND1FYc1xUS0Luk+H5PmsZ1IXpKO4Dc+J020OPPmfGQvRxpuShZv1uECsQB3Hn1l/S0Xymvtpahzd8P48p9NyoeSCD+MTt5Bsd1YAUa5iZ3ujIro7AA33ua5GcuT1Hs+YiKBX3MLt2Ne5iIjJ//9k="
    },
    {
      "base": "img-4774",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 1.5,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAQABgDASIAAhEBAxEB/8QAGAAAAgMAAAAAAAAAAAAAAAAAAAQBAgX/xAAjEAACAgIBAgcAAAAAAAAAAAABAgMRACEiMVEEBRRCgdHw/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAL/xAAVEQEBAAAAAAAAAAAAAAAAAAAAEf/aAAwDAQACEQMRAD8A2VkWr7ZT1EbzohsMPab2K6/GJweKTipOzrJnMskkaxrzW2Us1Cv2smqh6dlETMRYA6d8MSfzCMimoFTzUna/eGKP/9k="
    },
    {
      "base": "img-4790",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAQBAwUC/8QAJBAAAgEEAQMFAQAAAAAAAAAAAQIAAxESIQQTIjEFFDJBcZH/xAAYAQEBAAMAAAAAAAAAAAAAAAACAQADBP/EABoRAQEAAgMAAAAAAAAAAAAAAAABAhESITH/2gAMAwEAAhEDEQA/AOfmanUb438C1jaZ49RUZiQSpWxkodg2J0w3aV0xdSGp5M+8r2xnPTiblFQ6PRB6eIax+jbcTy26LhgNIGDf3URztFfpvG6fIDcihkALhmP3+S72z8rkVS5UU1U4kaPmY6qhe4dg8geTNyctUyC0mKvYa+gIJlv1jjt6fVAsHYg2B7dG0TtEphl8f2IedXSRCS1iY5NVqIGFrk2udxEiRra7HuJb9iIjbH//2Q=="
    },
    {
      "base": "img-4791",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQAAAgMBAAAAAAAAAAAAAAAAAAQBAgUD/8QAJhAAAgIBBAECBwAAAAAAAAAAAQIAAxEEEhMhYUFRBSMxMnHR4f/EABgBAAMBAQAAAAAAAAAAAAAAAAABAgME/8QAGBEBAAMBAAAAAAAAAAAAAAAAAAEREiH/2gAMAwEAAhEDEQA/AM4WtbYrsSAB1+5FYxYML2CDFg3GVG4d99GO6a/iw5RbCTsww6E55XDjq2W2vKrts3HJz9Rgf2Elhm7B2lSWB8DA7hHqg66PQvVcjPXU6D7lPeY7qNGt2maxfllrd2APEleTA2gKAfaXG8jDOzD29JO+EzD8NYKSrvnB7HmE11KkYIhJ3J0WrYsZexyiEjBIHrCEQKcr3VhnY/gdCEITRb//2Q=="
    },
    {
      "base": "img-4797",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 1.5,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAQABgDASIAAhEBAxEB/8QAFgABAQEAAAAAAAAAAAAAAAAABQAD/8QAJRAAAgAFAwMFAAAAAAAAAAAAAQIAAwQREgUUIRMiQTFhgZHB/8QAFgEBAQEAAAAAAAAAAAAAAAAAAwAB/8QAFxEBAQEBAAAAAAAAAAAAAAAAAQAREv/aAAwDAQACEQMRAD8ANmVBp2VSO0kAL7HzGEzncHA25GQPkQrO0pKh1Ziy4gWAYW4+I1NEu2enSYgMxyxH1ACSowlMLhiGKsVNjl+RQrL0fpFSZyEKb2x9Yots5b//2Q=="
    },
    {
      "base": "img-4806",
      "folder": "gallery",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 0.667,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAkABgDASIAAhEBAxEB/8QAGQABAQADAQAAAAAAAAAAAAAAAAQBAgMF/8QAJxAAAQQBBAECBwAAAAAAAAAAAQACAxESBCExQRMFURUiQnGRobH/xAAYAQEBAAMAAAAAAAAAAAAAAAABAAIDBP/EABYRAQEBAAAAAAAAAAAAAAAAAAABEf/aAAwDAQACEQMRAD8A5zzP1MsmbsaFg12piMn7kij+QpxNwAST9uUL6kc2+9lzs1Xm8QLWvIBG9GrRQyWTYNi+kTi1qHYNca3P8WNbFLp5I8vrFg+4XePSSE/O0OF8XSq9V051k8UjCGtDNgdzymWB5odixtHntFR8OfjRk/SI2JcNgFuK9giLWWkjjiiIpP/Z"
    }
  ],
  "misc": {
    "og-card": {
      "base": "og-card",
      "folder": "misc",
      "widths": [
        480,
        1280,
        2560
      ],
      "aspect": 1.5,
      "lqip": "data:image/jpeg;base64,/9j/2wBDABQODxIPDRQSEBIXFRQYHjIhHhwcHj0sLiQySUBMS0dARkVQWnNiUFVtVkVGZIhlbXd7gYKBTmCNl4x9lnN+gXz/2wBDARUXFx4aHjshITt8U0ZTfHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHx8fHz/wAARCAAQABgDASIAAhEBAxEB/8QAFwAAAwEAAAAAAAAAAAAAAAAAAAQFAv/EACMQAAIBAwMEAwAAAAAAAAAAAAECAwARIQQFEhMjMWFRkaH/xAAUAQEAAAAAAAAAAAAAAAAAAAAA/8QAFBEBAAAAAAAAAAAAAAAAAAAAAP/aAAwDAQACEQMRAD8AmadwwCqGLEtb8FMydlJZhZgWJNmvn4xSe2I8szrGuCbEjyL1QmZU2zVaVIREyNytYgk4zf3mgxFvbaV0HSJUoCCMH6oqTJy7XM+Ljz7ooP/Z"
    }
  }
};
